export default "__VITE_ASSET__BmBcsNoZ__"